import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const SuspiciousTransactionFeed = ({ transactions, onInvestigate }) => {
  const [filter, setFilter] = useState('all');

  const getRiskColor = (score) => {
    if (score >= 80) return 'text-error bg-error/10';
    if (score >= 60) return 'text-warning bg-warning/10';
    return 'text-accent bg-accent/10';
  };

  const getStatusBadge = (status) => {
    const badges = {
      pending: { color: 'bg-warning/10 text-warning', label: 'Menunggu', icon: 'Clock' },
      investigating: { color: 'bg-primary/10 text-primary', label: 'Investigasi', icon: 'Search' },
      blocked: { color: 'bg-error/10 text-error', label: 'Diblokir', icon: 'ShieldOff' },
      cleared: { color: 'bg-success/10 text-success', label: 'Aman', icon: 'ShieldCheck' }
    };
    return badges?.[status] || badges?.pending;
  };

  const filteredTransactions = filter === 'all' 
    ? transactions 
    : transactions?.filter(t => t?.status === filter);

  return (
    <div className="bg-card border border-border rounded-xl shadow-sm h-full flex flex-col">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4">
          <div>
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-1">
              Transaksi Mencurigakan
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground">
              {filteredTransactions?.length} transaksi memerlukan perhatian
            </p>
          </div>
          <Button
            variant="outline"
            size="sm"
            iconName="RefreshCw"
            iconPosition="left"
          >
            Refresh
          </Button>
        </div>

        <div className="flex flex-wrap gap-2">
          {['all', 'pending', 'investigating', 'blocked']?.map((status) => (
            <button
              key={status}
              onClick={() => setFilter(status)}
              className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-smooth ${
                filter === status
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground hover:bg-muted/80'
              }`}
            >
              {status === 'all' ? 'Semua' : status === 'pending' ? 'Menunggu' : status === 'investigating' ? 'Investigasi' : 'Diblokir'}
            </button>
          ))}
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-4 md:p-6 space-y-4">
        {filteredTransactions?.map((transaction) => {
          const badge = getStatusBadge(transaction?.status);
          return (
            <div
              key={transaction?.id}
              className="border border-border rounded-xl p-4 hover:shadow-md transition-smooth"
            >
              <div className="flex items-start gap-3 mb-3">
                <Image
                  src={transaction?.merchantLogo}
                  alt={transaction?.merchantLogoAlt}
                  className="w-10 h-10 md:w-12 md:h-12 rounded-lg object-cover flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2 mb-1">
                    <h4 className="text-sm font-semibold text-foreground line-clamp-1">
                      {transaction?.merchantName}
                    </h4>
                    <span className={`px-2 py-1 rounded-lg text-xs font-semibold whitespace-nowrap ${getRiskColor(transaction?.riskScore)}`}>
                      {transaction?.riskScore}%
                    </span>
                  </div>
                  <p className="text-xs text-muted-foreground mb-2">
                    ID: {transaction?.transactionId}
                  </p>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-lg text-xs font-medium ${badge?.color}`}>
                      <Icon name={badge?.icon} size={12} />
                      {badge?.label}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      {transaction?.timestamp}
                    </span>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3 mb-3 p-3 bg-muted/50 rounded-lg">
                <div>
                  <p className="text-xs text-muted-foreground mb-1">Jumlah</p>
                  <p className="text-sm font-semibold text-foreground">{transaction?.amount}</p>
                </div>
                <div>
                  <p className="text-xs text-muted-foreground mb-1">Metode</p>
                  <p className="text-sm font-semibold text-foreground">{transaction?.paymentMethod}</p>
                </div>
              </div>
              <div className="mb-3">
                <p className="text-xs text-muted-foreground mb-2">Indikator Risiko:</p>
                <div className="flex flex-wrap gap-1.5">
                  {transaction?.riskIndicators?.map((indicator, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center gap-1 px-2 py-1 bg-error/10 text-error rounded text-xs"
                    >
                      <Icon name="AlertCircle" size={10} />
                      {indicator}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-2">
                <Button
                  variant="default"
                  size="sm"
                  iconName="Eye"
                  iconPosition="left"
                  onClick={() => onInvestigate(transaction)}
                  className="flex-1"
                >
                  Investigasi
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  iconName="Ban"
                  iconPosition="left"
                  className="flex-1"
                >
                  Blokir
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SuspiciousTransactionFeed;